import React, { useState } from "react";
import { Breadcrumb, SimpleCard } from "@gull";
import { Formik } from "formik";
import { Helmet } from "react-helmet";

import { model, validationModel } from "./addIpUtility";
import { RenderCheckboxInput, RenderTextInput } from "app/common/renderInput";

import { addIP } from "app/services/ipService";

import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import MemberAutoComplete from "./MemberAutocomplete";

function AddIpVendor() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const handleSubmit = async (values) => {
    setShow(true);

    const res = await addIP(values);

    try {
      if (res.status == "Success") {
        navigate("/admin/ip-vendor");
        NotificationManager.success(res.message);
        setShow(false);
      } else {
        NotificationManager.error(res.message);
        setShow(false);
      }
    } catch (error) {
      NotificationManager.error(error);
      setShow(false);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Add Ip Vendor</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[
          { name: "IP Vendor List", path: "/admin/ip-vendor" },
          { name: "Add Ip Vendor" },
        ]}
      ></Breadcrumb>
      <div>
        <Formik
          initialValues={model}
          validationSchema={validationModel}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            isValid,
            dirty,
            setFieldValue,
          }) => {
            return (
              <form
                className="needs-validation"
                onSubmit={handleSubmit}
                noValidate
              >
                {/* <div>
                        <div className="col-md-12">
                          {Object.values(errors).map(msg => (
                            <>
                              {msg}
                              <br />
                            </>
                          ))}
                        </div>
                      </div> */}
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    <SimpleCard title="Personal Details" className="mb-4">
                      <div className="row">
                        <MemberAutoComplete
                          setFieldValue={setFieldValue}
                          handleChangeOptions={(value) => {
                            const selectedMemberId = value.id;
                            setFieldValue("memId", selectedMemberId);
                          }}
                          name="memId"
                          value={values.memId}
                        />
                        {!values.memId ? (
                          <p className="text-danger">{errors.memId}</p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="ipAddress"
                          display="Ip Address"
                          placeholder="Ip Address"
                          value={values.ipAddress}
                          error={errors.ipAddress}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          touched={touched.ipAddress}
                          required
                        ></RenderTextInput>
                      </div>

                      <Row className="mb-3">
                        <Col sm={12} xs={12} lg={6} md={6} xl={6}>
                          <RenderTextInput
                            type="text"
                            name="macIPAddress"
                            display="MAC IP Address"
                            placeholder="MAC IP Address"
                            value={values.macIPAddress}
                            error={errors.macIPAddress}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            touched={touched.macIPAddress}
                            required
                          ></RenderTextInput>
                        </Col>
                        <Col sm={12} xs={12} lg={6} md={6} xl={6}>
                          <RenderTextInput
                            type="text"
                            name="domainName"
                            display="Domain Name"
                            placeholder="Domain Name"
                            value={values.domainName}
                            error={errors.domainName}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            touched={touched.domainName}
                            required
                          ></RenderTextInput>
                        </Col>
                      </Row>

                      <div className="row">
                        <RenderCheckboxInput
                          type="switch"
                          name="status"
                          display="Active"
                          value={values.status ? values.status : ""}
                          error={errors.status}
                          onChange={(e) => {
                            setFieldValue("status", e.currentTarget.checked);
                          }}
                          onBlur={handleBlur}
                          touched={touched.status}
                        ></RenderCheckboxInput>
                      </div>
                    </SimpleCard>
                  </div>
                </div>

                {show ? (
                  <Button variant="primary" disabled>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      style={{ marginRight: "10px" }}
                    />
                    <span> Adding...</span>
                  </Button>
                ) : (
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                )}
              </form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
}

export default AddIpVendor;
